import { errorText } from "./errorText";

export function ErrorLine({ error }: { error: unknown }) {
  if (!error) return null;
  return (
    <div className="rounded-[var(--radius-ui)] border border-err/30 bg-err-bg px-3 py-2 text-[12.5px] text-err">
      {errorText(error)}
    </div>
  );
}
